/**
 * SAP-Zeitstempel des Adapters ("YYYYMMDDTHHMMSS", sy-datum/sy-uzeit = SAP-Systemzeit)
 * -> "DD.MM.YYYY HH:MM". Kein Zeitzonen-Umrechnen: die Anzeige sagt "Systemzeit" dazu.
 */
export const fmtSapTs = (ts) => {
  const s = String(ts || '');
  if (s.length < 15) return s;
  return `${s.slice(6, 8)}.${s.slice(4, 6)}.${s.slice(0, 4)} ${s.slice(9, 11)}:${s.slice(11, 13)}`;
};
